import { render, staticRenderFns } from "./exportLiquidacion.vue?vue&type=template&id=297a5338&scoped=true"
import script from "./exportLiquidacion.vue?vue&type=script&lang=js"
export * from "./exportLiquidacion.vue?vue&type=script&lang=js"
import style0 from "./exportLiquidacion.vue?vue&type=style&index=0&id=297a5338&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297a5338",
  null
  
)

export default component.exports